<template>
    <div class="container-fluid mt-5">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Ingresos por Tipo de Consulta</h3>
                <p class="text-muted">Visualiza los ingresos generados por cada tipo de consulta.</p>
            </div>
            <div class="col-md-12 text-center">
                <div v-if="isLoading">
                    <vs-spinner color="rgb(59,222,200)" />
                </div>
                <div v-else>
                    <apexchart type="pie" :options="chartOptions" :series="chartSeries" height="350" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "IngresosConsulta",
    components: {
        apexchart: VueApexCharts
    },
    props: {
        personal_medico_id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            chartOptions: {
                labels: [], // Tipos de consulta
                colors: ["#3bdec8", "#ff9f40", "#ffcd56", "#4caf50", "#f44336"],
                legend: {
                    position: "bottom"
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `$${val.toLocaleString()} MXN`;
                        }
                    }
                }
            },
            chartSeries: [] // Ingresos por tipo de consulta
        };
    },
    mounted() {
        this.fetchIngresosConsulta();
    },
    methods: {
        async fetchIngresosConsulta() {
            try {
                const response = await axios.get(`${API}/ingresos_por_tipo_consulta`, {
                    params: {
                        personal_medico_id: this.personal_medico_id
                    }
                });

                if (response.data.status === "success") {
                    const data = response.data.data;
                    this.chartOptions.labels = data.map(item => item.tipo_consulta);
                    this.chartSeries = data.map(item => item.total_ingresos);
                } else {
                    this.notify("error", "No se pudo obtener los ingresos por tipo de consulta.");
                }
            } catch (error) {
                console.error(error);
                this.notify("error", `Error: ${error.response?.data?.message || error.message}`);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.text-main-gradient {
    background: linear-gradient(to right, #3bdec8, #59bfff);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
